import { Months } from '../../data/models/Invoice'
const getMonthName = {
  '01': Months.Jan,
  '02': Months.Feb,
  '03': Months.Mar,
  '04': Months.Apr,
  '05': Months.May,
  '06': Months.Jun,
  '07': Months.Jul,
  '08': Months.Aug,
  '09': Months.Sep,
  '10': Months.Oct,
  '11': Months.Nov,
  '12': Months.Dec,
}
const GetInvoicesParser = (data: any): any => {
  const { invoices } = data?.data
  const parsedInvoices = invoices?.map((item) => {
    const invoice = {
      ...item,
      id: item?.file ?? '',
      month: getMonthName[item?.month ?? ''],
    }
    return invoice
  })
  return parsedInvoices
}

export { GetInvoicesParser }
